import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_CAPITAL_GAINS_TRANSACTIONS = 'REQUEST_CAPITAL_GAINS_TRANSACTIONS'
export const RECEIVE_CAPITAL_GAINS_TRANSACTIONS = 'RECEIVE_CAPITAL_GAINS_TRANSACTIONS'
export const SAVE_CAPITAL_GAINS_TRANSACTION = 'SAVE_CAPITAL_GAINS_TRANSACTION'
export const CREATE_CAPITAL_GAINS_TRANSACTION = 'CREATE_CAPITAL_GAINS_TRANSACTION'

export const requestCapitalGainsTransactions = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_CAPITAL_GAINS_TRANSACTIONS, data: { taxReturnId } })

    axios
        .get(`/capitalgainstransactions?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receiveCapitalGainsTransactions({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveCapitalGainsTransactions({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveCapitalGainsTransactions({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveCapitalGainsTransactions = (data) => ({ type: RECEIVE_CAPITAL_GAINS_TRANSACTIONS, data })

export const saveCapitalGainsTransaction = (data) => (dispatch) => {
    dispatch({ type: SAVE_CAPITAL_GAINS_TRANSACTION, data })

    const { id } = data

    return axios
        .put(`/capitalgainstransactions/${id}`, data)
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(
                receiveCapitalGainsTransactions({
                    items: [responseData],
                })
            )
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const updateAndSaveCapitalGainsTransactions = (data) => (dispatch) => {
    dispatch(receiveCapitalGainsTransactions({ items: [data] }))
    return dispatch(saveCapitalGainsTransaction(data)).catch(() => {})
}

export const createCapitalGainsTransaction = (data) => (dispatch, getState) => {
    dispatch({ type: CREATE_CAPITAL_GAINS_TRANSACTION, data })

    const { id: taxReturnId } = getState().taxReturn

    return axios
        .post(`/capitalgainstransactions`, { ...data, taxReturnId })
        .then((response) => {
            const responseData = response?.data || {}
            dispatch(receiveCapitalGainsTransactions({ items: [responseData] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
